import { render, staticRenderFns } from "./DocumentUpload.vue?vue&type=template&id=5e87b875&"
import script from "./DocumentUpload.vue?vue&type=script&lang=js&"
export * from "./DocumentUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports